import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative bg-slate-950 text-white p-12 items-end overflow-hidden">
        <img src="https://images.pexels.com/photos/12820604/pexels-photo-12820604.jpeg" alt="ramp" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative">
          <Logo size="xl" variant="dark" />
          <div className="mt-6 text-sky-300 text-xs font-mono uppercase tracking-widest">
            KSME · Admin Console
          </div>
          <div className="font-display text-4xl font-bold mt-3 leading-tight">
            Manage fuel, hangars,<br />schools & more.
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="section-label">Administrator Sign-in</div>
          <h1 className="font-display font-bold text-3xl mt-3 text-slate-950">Welcome back</h1>
          <p className="text-slate-600 mt-1">Sign in to manage the public site content.</p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-900 mb-1 block">Email</label>
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none"
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-900 mb-1 block">Password</label>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none"
                required
              />
            </div>
            {error && <div data-testid="admin-login-error" className="text-sm text-red-600">{error}</div>}
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-slate-950 text-white px-6 py-3 font-semibold hover:bg-slate-800 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
